var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#E1E9F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_625_5707)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 10,
    width: 20,
    height: 20,
    rx: 1.53846,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.1692,
    y: 9.16923,
    width: 21.6615,
    height: 21.6615,
    rx: 2.36923,
    stroke: "white",
    strokeWidth: 1.66154,
    strokeLinecap: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.769 23.0324H11.519V23.2824V27.6926C11.519 28.1735 11.7024 28.5949 12.0538 28.9463C12.4052 29.2977 12.8266 29.4811 13.3075 29.4811H17.7178H17.9678V29.2311V27.6926V27.4426H17.7178H13.5575V23.2824V23.0324H13.3075H11.769ZM24.0319 29.2311V29.4811H24.2819H28.6921C29.173 29.4811 29.5944 29.2977 29.9458 28.9463C30.2972 28.5949 30.4806 28.1735 30.4806 27.6926V23.2824V23.0324H30.2306H28.6921H28.4421V23.2824V27.4426H24.2819H24.0319V27.6926V29.2311ZM11.519 16.7182V16.9682H11.769H13.3075H13.5575V16.7182V12.558H17.7178H17.9678V12.308V10.7695V10.5195H17.7178H13.3075C12.8266 10.5195 12.4052 10.7029 12.0538 11.0543C11.7024 11.4057 11.519 11.8271 11.519 12.308V16.7182ZM28.4421 16.7182V16.9682H28.6921H30.2306H30.4806V16.7182V12.308C30.4806 11.8271 30.2972 11.4057 29.9458 11.0543C29.5944 10.7029 29.173 10.5195 28.6921 10.5195H24.2819H24.0319V10.7695V12.308V12.558H24.2819H28.4421V16.7182Z",
    fill: "#1C53EC",
    stroke: "#1C53EC",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_625_5707",
    x: 5.64607,
    y: 4.64656,
    width: 30.7079,
    height: 30.7069,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.84615
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_625_5707"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_625_5707",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.345ece4dd15d30896bd8af82cf4c6373.svg";
export { ForwardRef as ReactComponent };